'use client'

import ListingsStandard, { SkeletonCard, SoldStandard } from '@component/card/listings/standard'
import Pagination from '@component/pagination'
import useFetch from '@hooks/useFetch'
import { first, get, map, range, size } from 'lodash-es'
import { useCallback, useMemo } from 'react'
import { OfficeListingsTypes, useOfficeListingsContext } from './context'
import SectionTabs from '@component/layout/section/tabs'
import { officeDataLayer } from '@plugin/google/gtm/modules/office'

export default function OfficeListingsContent({
  defaultData,
  id,
  pageIndex,
  pageSize,
  totals
}) {

  const { pageIndex: pageIdx, setPageIndex, type } = useOfficeListingsContext()
  const isDefault = pageIdx === pageIndex && type === first(OfficeListingsTypes)

  const { data, isLoading } = useFetch(isDefault ? null : { url: `office/${id}/houses`, params: { limit: pageSize, offset: (pageIdx - 1) * pageSize, typeId: type.value } })
  const viewData = isDefault ? defaultData : data
  const viewTotals = useMemo(() => get(viewData, 'headers.x-total-count', totals), [viewData, totals])

  const changeHandle = useCallback(idx => {
    setPageIndex(idx)
  }, [setPageIndex])

  return (
    <>
      {
        isLoading && (
          <SkeletonOfficeListings></SkeletonOfficeListings>
        )
      }
      {
        !isLoading && size(viewData) > 0 && (
          <div className='grid grid-cols-1 gap-16 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
            {
              map(viewData, item => (
                type.value === -102
                  ? <SoldStandard data={item} key={item.id}></SoldStandard>
                  : <ListingsStandard data={item} key={item.id}></ListingsStandard>
              ))
            }
          </div>
        )
      }
      {
        viewTotals > pageSize && (
          <Pagination pageIndex={pageIdx} right pageSize={pageSize} totals={viewTotals} onChange={changeHandle} className='mt-20'></Pagination>
        )
      }
    </>
  )
}

export function OfficeListingsTab({
  id
}) {

  const { type, setType, setPageIndex } = useOfficeListingsContext()
  const changeType = useCallback(d => {
    setPageIndex(1)
    setType(d)
    officeDataLayer.listingsTabClick(d.event, id)
  }, [setType, setPageIndex, id])
  return (
    <SectionTabs data={OfficeListingsTypes} value={type} onChange={changeType}></SectionTabs>
  )
}
export function SkeletonOfficeListings({
  showTitle = false
}) {

  return (
    <div className='skeleton-wrap'>
      {showTitle && <span className='h-20 w-1/6 mb-20'></span>}
      <div className='grid grid-cols-1 md:grid-cols-4 gap-16'>
        {
          map(range(0, 8), idx => (
            <SkeletonCard key={idx}></SkeletonCard>
          ))
        }
      </div>
    </div>
  )
}